import { call, put, takeLatest, takeEvery } from 'redux-saga/effects'

import * as service from 'catalog/services/skus'

import { Constants, Actions } from './'

function * fetchSkus ({ id }) {
  try {
    const result = yield call(service.getSkus, id)
    yield put(Actions.getSkusSuccess(result))
  } catch (error) {
    yield put(
      Actions.getSkusFailure(
        'Não foi possível recuperar os outros preços. Tente novamente mais tarde.',
        error
      )
    )
  }
}

export default function * root () {
  yield takeLatest(Constants.SKUS_GET, fetchSkus)
}
